module.exports = __webpack_public_path__ + "static/Gerda-over-9a386e0d5740d00e6af53f19a4a1f057.png";